import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { MdClose } from "react-icons/md"
import PlSpecificationItems from "../PlSpecificationItems"

import {
  scale,
  calculateItemSalePrice,
  thousandSeparator
} from "utils"
import {
  languageSuffixMap,
  productUnitsSymbol
} from "constant"

const PloptfcustomerOrderDetails = (props) => {
  const { templateType, printData, printerWidth } = props

  const {
    items,
    total,
    subtotal,
    taxesAndCharges,
    totalDiscount,
    deliveryFee,
    deliveryType
  } = printData

  const [t, i18n] = useTranslation()

  const dir = i18n.dir(i18n.language)

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth, dir)
      : stylesOthers(dir)

  const getItemTotalSpecificationItems = (item) => {
    const result =
      item.specificationItems.reduce((t, specificationItem) =>
        t +=
        item.quantity *
        specificationItem.salePrice *
        (specificationItem.quantity - specificationItem.freeQuantity)
        , 0
      )
      || 0

    return result
  }

  const getItemTotal = (item) => {
    const totalSpecificationItems =
      getItemTotalSpecificationItems(item)

    const total =
      item.quantity *
      calculateItemSalePrice(item) +
      totalSpecificationItems

    return total
  }

  return (
    <div style={styles["container"]}>
      <div style={styles["text2"]}>
        {t("توضیحات")}:
      </div>

      <div style={styles["table-container"]}>
        <div style={styles["table"]}>
          <div style={styles["row"]}>
            <div style={styles["th_name"]}>
              <div style={styles["thText"]}>
                {t("نام کالا")}
              </div>
            </div>
            <div style={styles["th_qty"]}>
              <div style={styles["thText"]}>
                {t("واحد")}
              </div>
            </div>
            <div style={styles["th_price"]}>
              <div style={styles["thText"]}>
                {t("قیمت کل")}
              </div>
            </div>
          </div>

          {items.map((item, itemIndex) => (
            <div key={itemIndex} style={styles["row"]}>
              <div style={styles["td_name"]}>
                <div style={styles["tdText"]}>
                  {item[`foodName${languageSuffixMap[i18n.language]}`]}
                </div>
                {
                  !item.isSimple &&
                  <div style={styles["optionName"]}>
                    {item[`optionName${languageSuffixMap[i18n.language]}`]}
                  </div>
                }
                <PlSpecificationItems items={item.specificationItems} language={i18n.language}>
                  {(specificationItem, siIndex) =>
                    <div
                      key={siIndex}
                      style={styles["optionName"]}
                    >
                      {specificationItem[`name${languageSuffixMap[i18n.language]}`]}
                      {
                        !specificationItem.isSelectable &&
                        <Fragment>
                          <MdClose />
                          {specificationItem.quantity * item.quantity}
                        </Fragment>
                      }
                    </div>
                  }
                </PlSpecificationItems>
              </div>
              <div style={styles["td_qty"]}>
                <div style={styles["tdText"]}>
                  {item.quantity}
                  <span>{t(productUnitsSymbol[item.unit]) }</span>
                </div>
              </div>
              <div style={styles["td_price"]}>
                <div style={styles["tdText"]}>
                  {thousandSeparator(getItemTotal(item), "")}
                </div>
              </div>
            </div>
          )
          )}
        </div>
      </div>

      <div style={styles["summary"]}>
        <div style={styles["text4"]}>
          {t("مجموع اقلام")}
        </div>
        <div style={styles["text4"]}>
          {thousandSeparator(subtotal, "")}
        </div>
      </div>

      {
        totalDiscount > 0 &&
        <div style={styles["summary"]}>
          <div style={styles["text4"]}>
            {t("تخفیف")}
          </div>
          <div style={styles["text4"]}>
            {thousandSeparator(-totalDiscount, "")}
          </div>
        </div>
      }

      {
        deliveryType === "delivery" &&
        <div style={styles["summary"]}>
          <div style={styles["text4"]}>
            {t("هزینه ارسال")}
          </div>
          <div style={styles["text4"]}>
            {thousandSeparator(deliveryFee, "")}
          </div>
        </div>
      }

      {taxesAndCharges.map((tax, taxIndex) =>
        <div key={taxIndex} style={styles["summary"]}>
          <div style={styles["text4"]}>
            {tax[`title${languageSuffixMap[i18n.language]}`]} {tax.isPercentageModel ? `(${tax.percentage}%)` : ""}
          </div>
          <div style={styles["text4"]}>
            {thousandSeparator(tax.amount, "")}
          </div>
        </div>
      )}

      <div style={styles["summary"]}>
        <div style={styles["total"]}>
          {t("قابل پرداخت")}
        </div>
        <div style={styles["total"]}>
          {thousandSeparator(total)}
        </div>
      </div>
    </div>
  )
}

const stylesThermal = (printerWidth, dir = "rtl") => ({
  container: {
    fontSize: scale("19px", printerWidth),
    paddingTop: scale("10px")
  },

  text2: {
    marginBottom: scale("4px")
  },

  table: {
    width: "100%",
    border: `${scale("2px")} solid`
  },

  row: {
    display: "flex",
    flexDirection: "row",
  },

  td_name: {
    flex: 1.42,
    padding: scale("1px"),
    borderTop: `${scale("2px")} solid`,
    [dir === "rtl" ? "borderLeft" : "borderRight"]: `${scale("2px")} solid`,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },

  tdText: {

  },

  optionName: {
    fontWeight: "bold",
    display: "flex",
    alignItems: "center"
  },

  th_name: {
    flex: 1.42,
    padding: scale("1px"),
    color: "black"
  },

  th_qty: {
    flex: 0.4,
    padding: scale("1px"),
    color: "black"
  },

  th_price: {
    flex: 1,
    padding: scale("1px"),
    color: "black"
  },



  td_qty: {
    flex: 0.4,
    padding: scale("1px"),
    borderTop: `${scale("2px")} solid`,
    [dir === "rtl" ? "borderLeft" : "borderRight"]: `${scale("2px")} solid`,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center"
  },

  td_price: {
    flex: 1,
    padding: scale("1px"),
    borderTop: `${scale("2px")} solid`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  thText: {
    fontWeight: "bold",
    textAlign: "center",

  },

  summary: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: `${scale("2px")} solid`
  },

  phone: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    borderBottom: `${scale("2px")} solid`,
    [dir === "rtl" ? "borderLeft" : "borderRight"]: `${scale("2px")} solid`
  },

  tableContainer: {

  },

  text4: {
    flex: 1,
    textAlign: "center",
    [dir === "rtl" ? "borderRight" : "borderLeft"]: `${scale("2px")} solid`,
    borderTop: `${scale("2px")} solid`
  },

  total: {
    flex: 1,
    textAlign: "center",
    fontSize: scale("26px", printerWidth),
    color: "black",
    border: "1px solid",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: "0px"
  }
})

const stylesOthers = (dir = "rtl") => ({
  container: {
    [dir === "rtl" ? "marginRight" : "marginLeft"]: "8px",
    paddingTop: "8px",
    fontSize: "11px"
  },

  row: {
    display: "flex",
    flexDirection: "row"
  },

  table: {
    width: "100%",
    border: "1px solid"
  },

  th_name: {
    flex: 1.42,
    color: "black",
    padding: "1px"
  },

  th_qty: {
    flex: 0.4,
    padding: "1px",
    color: "black"
  },

  th_price: {
    flex: 1,
    padding: "1px",
    color: "black"
  },

  td_name: {
    flex: 1.406,
    padding: "1px",
    borderTop: "1px solid",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: "1px solid",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },

  td_qty: {
    flex: 0.4,
    padding: "1px",
    borderTop: "1px solid",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: "1px solid",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center"
  },

  td_price: {
    flex: 1,
    padding: "1px",
    borderTop: "1px solid",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  thText: {
    fontWeight: "bold",
    textAlign: "center"
  },

  optionName: {
    fontWeight: "bold",
    display: "flex",
    alignItems: "center"
  },

  summary: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: "1px solid black",
    outline: 0
  },

  text4: {
    flex: 1,
    textAlign: "center",
    [dir === "rtl" ? "borderRight" : "borderLeft"]: "1px solid",
    borderTop: "1px solid"
  },


  total: {
    flex: 1,
    fontSize: "18px",
    textAlign: "center",
    color: "black",
    border: "1px solid",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: "0px"
  },

  text2: {
    marginBottom: "5px",
  }
})

export default PloptfcustomerOrderDetails
